import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useOrigin } from './OriginContext';

/**
 * OriginLoader — The 3px unified ecosystem loader.
 * Appears during global application loading or state transitions.
 */
const OriginLoader: React.FC = () => {
  const { state } = useOrigin();
  const isLoading = state === 'loading';
  const MotionDiv = motion.div as any;

  return (
    <AnimatePresence>
      {isLoading && (
        <MotionDiv
          className="origin-loader-container"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: '3px' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 } as any}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            background: 'rgba(0,0,0,0.1)',
            overflow: 'hidden'
          }}
        >
          <MotionDiv
            className="origin-loader-bar"
            animate={{
              left: ['-50%', '150%']
            } as any}
            transition={{
              duration: 2.0,
              repeat: Infinity,
              ease: [0.16, 1, 0.3, 1]
            } as any}
            style={{
              position: 'absolute',
              top: 0,
              width: '40%',
              height: '100%',
              background: 'linear-gradient(90deg, transparent, var(--color-accent-500), transparent)',
              boxShadow: '0 0 10px var(--color-accent-500)'
            }}
          />
        </MotionDiv>
      )}
    </AnimatePresence>
  );
};

export default OriginLoader;
